export default __webpack_public_path__ + "static/media/Rectangle 1655-tata-neu.a6269ccf.png";